import React from 'react';
import { SmartDrawer } from '../ui/feedback/SmartDrawer';
import { IconAppGallery } from '../ui/icon/IconAppGallery';
import { IconAppQr } from '../ui/icon/IconAppQr';
import { IconAppStore } from '../ui/icon/IconAppStore';
import { IconGooglePlay } from '../ui/icon/IconGooglePlay';
import { Box } from '../ui/layout/Box';
import { DataTestId } from '../ui/layout/DataTestIdWrapper';
import { Flex } from '../ui/layout/Flex';
import { Typography } from '../ui/typography/Typography';
import { getWindow } from '../utils/getWindow';
import { useBackButton } from '../utils/useBackButton';
import { useTranslation } from '../utils/useTranslation';

export function AppsQrDialog() {
    const t = useTranslation();
    const onNavigateBack = useBackButton();

    return (
        <SmartDrawer
            onClose={onNavigateBack}
            mainContent={
                <Box mb={1} width="100%" dataTestId={DataTestId.APPS_QR_DIALOG}>
                    <IconAppQr
                        fontSize={240}
                        style={{ margin: '12px auto 24px auto' }}
                        color="var(--color-primary)"
                    />
                    <Typography
                        variant="body"
                        color="var(--color-primary)"
                        weight="bold"
                        m="auto"
                        width="80%"
                        textAlign="center"
                    >
                        {t('Отсканируйте QR-код, чтобы скачать мобильное приложение')}
                    </Typography>
                    <Flex
                        m="auto"
                        pt={2}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <IconGooglePlay
                            height="40px"
                            fontSize="135px"
                            style={{ cursor: 'pointer' }}
                            onClick={() => getWindow()?.open('https://clck.ru/3EJ4v5', '_blank')}
                        />
                        <IconAppStore
                            height="40px"
                            fontSize="120px"
                            style={{ cursor: 'pointer', marginLeft: 8 }}
                            onClick={() => getWindow()?.open('https://clck.ru/3EJ4q2', '_blank')}
                        />
                        <IconAppGallery
                            height="40px"
                            fontSize="134px"
                            style={{ cursor: 'pointer', marginLeft: 8 }}
                            onClick={() => getWindow()?.open('https://clck.ru/3EJ56t', '_blank')}
                        />
                    </Flex>
                </Box>
            }
        />
    );
}
